export default {
    services: 'บริการของเรา',
    portfolio: 'ผลงาน',
    clients: 'ลูกค้า',
    contact: 'ติดต่อ'
}
